/**
 * @description Maps a php date format token to an equivalent format token in date_fns
 *
 * @see php Format tokens here https://www.php.net/manual/en/datetime.format.php
 * @see date-fns Format tokens here https://date-fns.org/v2.30.0/docs/format
 */
export var PHP_TO_DATE_FNS_FORMAT_TOKEN_MAP = {
    d: 'dd',
    D: 'EEE',
    jS: 'do',
    j: 'd',
    l: 'EEEE',
    N: 'i',
    w: '',
    z: '',
    W: 'I',
    F: 'MMMM',
    m: 'MM',
    M: 'MMM',
    n: 'M',
    t: '',
    L: '',
    o: 'YYYY',
    Y: 'yyyy',
    y: 'yy',
    a: 'a',
    A: 'aa',
    B: '',
    g: 'h',
    G: 'H',
    h: 'hh',
    H: 'HH',
    i: 'mm',
    s: 'ss',
    u: 'SSSS',
    v: 'SSS',
    e: '',
    I: '',
    O: 'x',
    P: 'xxx',
    T: '',
    Z: '',
    c: 'YYYY-MM-DD[T]HH:mm:ssZZ',
    r: '',
    U: 't',
};
//# sourceMappingURL=PHP_TO_DATE_FNS_FORMAT_TOKEN_MAP.js.map